import React from 'react'
import './style.scss'

export const BottomButtons = ({ navigationBtns }) => {

  return (
    <div className='bottomBtn'>
      {navigationBtns[0] && (
        <a
          className='bottomBtn__link bottomBtn__prev'
          href={navigationBtns[0].href}
        >
          <i className='bottomBtn__prev-icon'>&#8592;</i>
          Previous
          <span>{navigationBtns[0].title}</span>
        </a>
      )}
      {navigationBtns[1] && (
        <a
          className='bottomBtn__link bottomBtn__next'
          href={navigationBtns[1].href}
        >
          Next
          <i className='bottomBtn__next-icon'>&#8594;</i>
          <span>{navigationBtns[1].title}</span>
        </a>
      )}
    </div>
  )
}
